export function common() {
    return {
        baseUrl: process.env.BASE_URL,
    }
}
